import { useIsApplePayAvailable } from "@/features/wallet/hooks/useApplePay";
import { useIsGooglePayAvailable } from "@/features/wallet/hooks/useIsGooglePayAvailable";
import { useCreditCardsWithDeposit } from "@/hooks/firestore/user/useCreditCards";
import { useFiatCurrency } from "@/hooks/firestore/user/useFiatCurrency";

/**
 * Whether the user has an instant deposit method ready to go: Apple Pay,
 * Google Pay, or a saved card that has completed a deposit and has not
 * expired. Those methods are AUD only, so other currencies never qualify.
 */
export const useIsQuickDepositAvailable = () => {
  const isApplePayAvailable = useIsApplePayAvailable();
  const isGooglePayAvailable = useIsGooglePayAvailable();
  const cardsWithDeposit = useCreditCardsWithDeposit();
  const currency = useFiatCurrency();

  if (currency !== "AUD") return false;

  if (isApplePayAvailable || isGooglePayAvailable) return true;

  return (cardsWithDeposit?.length ?? 0) > 0;
};
